import { GridApi } from 'ag-grid-community';

export interface GridSizeFunction {
  (gridApi: GridApi | null): GridSize;
}

export interface GridSize {
  width: number;
  height: number;
  field: number;
}

export const getGridSize: GridSizeFunction = (gridApi: GridApi | null) => {
  const rowsCount = gridApi ? gridApi.getDisplayedRowCount() : 0;
  const columnsCount = gridApi ? gridApi.getAllDisplayedColumns()?.length ?? 0 : 0;

  return {
    width: columnsCount,
    height: rowsCount,
    field: columnsCount * rowsCount,
  };
};
